import React from 'react'

import { useLocation } from 'react-router-dom'

import Iframe from '@/components/iframe/iframe.component'

const Importacoes = () => {
  const location = useLocation()
  const appImportacoesUrl = process.env.VITE_APP_IMPORTACOES_URL
  const iframeURL = React.useMemo(
    () => appImportacoesUrl + location.pathname + location?.search,
    [location]
  )
  const [isIframeLoaded, setIsIframeLoaded] = React.useState(false)

  function handleIframeLoad() {
    setIsIframeLoaded(true)
  }

  return (
    <>
      <Iframe
        onLoad={handleIframeLoad}
        url={`${iframeURL}`}
        isVisible={isIframeLoaded}
      />
    </>
  )
}

export default Importacoes
